
// localStoreOpportunitiesMode values
export const PDF_APPLICATION = 'PDF_APPLICATION'
export const THIRD_PARTY_URL = 'THIRD_PARTY_URL'
export const PREDICTIVE_PROFILES = 'PREDICTIVE_PROFILES'
export const STORE_EMAIL = 'STORE_EMAIL'

// Titles
export const SELECT_STORE_TITLE = 'Select Store'
export const APPLY_TODAY_TITLE = 'Apply Now'
export const CHANGE_STORE_TITLE = 'Change Store'
export const SUBMIT_EMAIL_TITLE = 'Submit an application to your local store today'
export const REQUEST_AN_APPLICATION = 'Request an Application'

export const LINK_DATA_ATTRIBUTE_NAME = 'localStoreOpportunitiesMode'

export const PREDICTIVE_PROFILES_DEFAULT_URL = 'http://www.applyatbigotires.com/'
